import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {useTranslation} from 'react-i18next';
import InputSuggest from '../../../Inputs/InputSuggest';
import { getCarenciaCF, getDespesaContratoCF, getDuracaoCF, getEntradaInicialCF, getNumRendaCF, getPortesMesCF, getRendaMensalCF, getSeguroCascoMesCF, getSeguroRespCivilCF, getTaxaNominalCF, getValorResidualCF } from '../../../../pages/requests';
import { useEffect } from 'react';

function ContratoFinanceiro({
    condicoesPagamento,
    setCondicoesPagamento,
    setOnChangeForm,
    editarProposta,
    duracao,
    setDuracao,
    carencia,
    setCarencia,
    numRendas,
    setNumRendas,
    portesMes,
    setPortesMes,
    seguroCivil,
    setSeguroCivil,
    taxaNominal,
    setTaxaNominal,
    entradaInicial,
    setEntradaInicial,
    rendaMensal,
    setRendaMensal,
    valorResidual,
    setValorResidual,
    seguroCasco,
    setSeguroCasco,
    despesasContrato,
    setDespesasContrato,
    //arrays
    arrayCondicoesPagamento,
    arrayDuracao,
    arrayCarencia,
    arrayNumRendas,
    arrayPortesMes,
    arraySeguroCivil,
    arrayTaxaNominal,
    arrayEntradaInicial,
    arrayRendaMensal,
    arrayValorResidual,
    arraySeguroCasco,
    arrayDespesasContrato,

    setArrayDuracao,
    setArrayCarencia,
    setArrayNumRendas,
    setArrayPortesMes,
    setArraySeguroCivil,
    setArrayTaxaNominal,
    setArrayEntradaInicial,
    setArrayRendaMensal,
    setArrayValorResidual,
    setArraySeguroCasco,
    setArrayDespesasContrato,
}) {
    debugger;
    const {t} = useTranslation();

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }

    useEffect(() => {
        getDuracaoCF(lang).then(res => {
            setArrayDuracao(res.data.duracaoCF);
        });
        getCarenciaCF(lang).then(res => {
            setArrayCarencia(res.data.carenciaCF);
        });
        getNumRendaCF(lang).then(res => {
            setArrayNumRendas(res.data.numRendaCF);
        });
        getPortesMesCF(lang).then(res => {
            setArrayPortesMes(res.data.portesMesCF);
        });
        getSeguroRespCivilCF(lang).then(res => {
            setArraySeguroCivil(res.data.seguroRespCivilCF);
        });
        getTaxaNominalCF(lang).then(res => {
            setArrayTaxaNominal(res.data.taxaNominalCF);
        });
        getEntradaInicialCF(lang).then(res => {
            setArrayEntradaInicial(res.data.entradaInicialCF);
        });
        getRendaMensalCF(lang).then(res => {
            setArrayRendaMensal(res.data.rendaMensalCF);
        });
        getValorResidualCF(lang).then(res => {
            setArrayValorResidual(res.data.valorResidualCF);
        });
        getSeguroCascoMesCF(lang).then(res => {
            setArraySeguroCasco(res.data.seguroCascoMesCF);
        });
        getDespesaContratoCF(lang).then(res => {
            setArrayDespesasContrato(res.data.despesaContratoCF);
        });
    }, []);

    return (
        <div className="z-10">
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                {/* <div>
                <label htmlFor="representante" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('condicoesPagamento')}
                </label>
                <input
                    value={condicoesPagamento}
                    // maxLength={20}
                    type="text"
                    id="nome"
                    className={`bg-white border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                    required
                    onChange={e => {
                        setOnChangeForm(true);
                        setCondicoesPagamento(e.target.value);
                    }}
                    disabled={!editarProposta}
                />
            </div> */}
                <div className="z-10">
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white z-10'">
                        {t('duracao')}
                    </label>

                    <InputSuggest
                        value={duracao}
                        onChange={value => {
                            setDuracao(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayDuracao}
                        disabled={!editarProposta}
                    />
                </div>
                <div className="z-10">
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white z-10'">
                        {t('carencia')}
                    </label>

                    <InputSuggest
                        value={carencia}
                        onChange={value => {
                            setCarencia(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayCarencia}
                        disabled={!editarProposta}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-3 z-10">
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('numRenda')}
                    </label>

                    <InputSuggest
                        value={numRendas}
                        onChange={value => {
                            setNumRendas(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayNumRendas}
                        disabled={!editarProposta}
                    />
                </div>
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('portesMes')}
                    </label>

                    <InputSuggest
                        value={portesMes}
                        onChange={value => {
                            setPortesMes(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayPortesMes}
                        disabled={!editarProposta}
                    />
                </div>
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('seguroCivil')}
                    </label>

                    <InputSuggest
                        value={seguroCivil}
                        onChange={value => {
                            setSeguroCivil(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arraySeguroCivil}
                        disabled={!editarProposta}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-3 z-10">
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('taxaNominal')}
                    </label>

                    <InputSuggest
                        value={taxaNominal}
                        onChange={value => {
                            setTaxaNominal(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayTaxaNominal}
                        disabled={!editarProposta}
                    />
                </div>
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('entradaInicial')}
                    </label>

                    <InputSuggest
                        value={entradaInicial}
                        onChange={value => {
                            setEntradaInicial(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayEntradaInicial}
                        disabled={!editarProposta}
                    />
                </div>
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('rendaMensal')}
                    </label>

                    <InputSuggest
                        value={rendaMensal}
                        onChange={value => {
                            setRendaMensal(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayRendaMensal}
                        disabled={!editarProposta}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-3 z-10">
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('valorResidual')}
                    </label>

                    <InputSuggest
                        value={valorResidual}
                        onChange={value => {
                            setValorResidual(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayValorResidual}
                        disabled={!editarProposta}
                    />
                </div>
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('seguroCasco')}
                    </label>

                    <InputSuggest
                        value={seguroCasco}
                        onChange={value => {
                            setSeguroCasco(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arraySeguroCasco}
                        disabled={!editarProposta}
                    />
                </div>
                <div>
                    <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('despesaContrato')}
                    </label>

                    <InputSuggest
                        value={despesasContrato}
                        onChange={value => {
                            setDespesasContrato(value);
                            setOnChangeForm(true);
                        }}
                        suggestions={arrayDespesasContrato}
                        disabled={!editarProposta}
                    />
                </div>
            </div>
        </div>
    );
}
export default ContratoFinanceiro;
